// extracted by mini-css-extract-plugin
export default {"text":"dhbrm__text--d33b9"};